import {
  AccredibleGroup,
  AccredibleOpenSearchApiParsedResponse,
  AccredibleOpenSearchApiRequestBody,
} from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { DashboardGroup } from '../entities/db-groups.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardGroupsApiService extends DashboardApiService {
  readonly GROUPS_API_URL = `/v1/issuer/organizations/${this.embedding.departmentId}/groups`;

  searchGroups(
    requestBody: AccredibleOpenSearchApiRequestBody,
  ): Observable<AccredibleOpenSearchApiParsedResponse<DashboardGroup>> {
    return this._post(`${this.GROUPS_API_URL}/search`, requestBody).pipe(
      map((res) => this._handleOpenSearchResponse<DashboardGroup>(res.body)),
      catchError((res) => this._handleError(res)),
    );
  }

  loadDefaultGroupSettings(): Observable<AccredibleGroup> {
    return this._get(`${this.GROUPS_API_URL}/default`).pipe(
      map((res) => this._handleResponse(res, 'group')),
      catchError((res) => this._handleError(res)),
    );
  }
}
